<div class="close-button-container" (click)="dismiss()"><smart-icon name="f"></smart-icon></div>
<div class="info-container">
  <div class="modal-title">{{this.title}}</div>
  <div class="description" *ngIf="this.isHtml" [innerHTML]="this.description | unescapeHtml"></div>
  <div class="description text" *ngIf="!this.isHtml">{{this.description}}</div>
</div>